export const CloseIcon = ({ className, onClick, onFocus }: {className: string; onClick?: () => void; onFocus?: () => void }) => (
  <svg onFocus={onFocus} onClick={onClick} className={`${className} select-none`} viewBox="0 0 24 24" fill="none">
    <path d="M6 6L18 18M18 6L6 18" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
